// Mock data for Salmons Brothers construction website
// NOTE: All data here is MOCKED for the frontend teaser. Contact form is wired to backend.

export const company = {
  name: "Salmons Brothers",
  tagline: "Construction Company",
  since: 1965,
  yearsExperience: 60,
  phone: "01353 662866",
  phoneHref: "tel:01353662866",
  email: "enquiries@salmonsbrothers.co.uk",
  address: "William House, 61 Lancaster Way, Ely, Cambridgeshire CB6 3NW",
  intro:
    "Established family run construction business based in Cambridgeshire.",
  about:
    "Our approach to building is based on our core family values - Honesty, integrity, quality and trust. These values are at the forefront of this family run and operated successful company trading since 1965. Our success and longevity is because of these.",
  about2:
    "With over 60 years experience, our high quality staff and trusted sub-contractors will take your project from the drawing stage to right through to completion.",
  about3:
    "Project based Contract Managers will keep you informed and ensure smooth running of the build throughout the process, engaging at all times to make sure the project is how the client envisages it to be. No job is too small and the customer will always come first.",
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
];

export const heroStats = [
  { value: 60, suffix: "+", label: "Years of trusted experience" },
  { value: 850, suffix: "+", label: "Projects completed with care" },
];

export const services = [
  {
    id: "new-builds",
    title: "New Builds",
    desc: "Bespoke homes and developments taken from the drawing stage right through to a finished, quality build.",
    img: "https://images.unsplash.com/photo-1710883727427-59d1ccc368fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "HardHat",
  },
  {
    id: "brickwork",
    title: "Brickwork & Architecture",
    desc: "Traditional and contemporary brickwork delivered by skilled craftsmen with an eye for detail.",
    img: "https://images.unsplash.com/photo-1701850009190-2859ba2aeea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Building2",
  },
  {
    id: "foundations",
    title: "Foundations & Groundwork",
    desc: "Solid, reliable foundations and groundworks that give every project the strongest possible start.",
    img: "https://images.unsplash.com/photo-1582540730843-f4418d96ccbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Layers",
  },
  {
    id: "extensions",
    title: "Extensions & Renovations",
    desc: "Sympathetic extensions and full renovations that add space, value and comfort to your home.",
    img: "https://images.unsplash.com/photo-1593786267440-550458cc882a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Home",
  },
  {
    id: "flooring",
    title: "Flooring & Screeding",
    desc: "Precise flooring and screeding installations providing a level, durable base for any interior.",
    img: "https://images.unsplash.com/photo-1731185752376-a4cf3e8556fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Ruler",
  },
  {
    id: "commercial",
    title: "Commercial Projects",
    desc: "Offices, units and commercial builds managed end to end with minimal disruption to your business.",
    img: "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Briefcase",
  },
];

export const projects = [
  {
    id: "p1",
    title: "Contemporary Family Home",
    category: "New Build",
    client: "Private Client",
    date: "March 2024",
    img: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "p2",
    title: "Ely Riverside Residence",
    category: "Renovation",
    client: "Private Client",
    date: "January 2024",
    img: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "p3",
    title: "Cambridgeshire New Build",
    category: "New Build",
    client: "Local Developer",
    date: "November 2023",
    img: "https://images.unsplash.com/photo-1621983209348-7b5a63f23866?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "p4",
    title: "Lancaster Way Offices",
    category: "Commercial",
    client: "Business Park",
    date: "September 2023",
    img: "https://images.unsplash.com/photo-1676679879918-700f13372796?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "p5",
    title: "Traditional Barn Conversion",
    category: "Renovation",
    client: "Private Client",
    date: "June 2023",
    img: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "p6",
    title: "Mixed-Use Development",
    category: "Commercial",
    client: "Regional Developer",
    date: "February 2023",
    img: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const stats = [
  { value: 850, suffix: "+", label: "Projects Completed", icon: "Trophy" },
  { value: 60, suffix: "+", label: "Years Established", icon: "CalendarDays" },
  { value: 100, suffix: "%", label: "Client Satisfaction", icon: "Smile" },
  { value: 45, suffix: "+", label: "Skilled Team & Trades", icon: "Users" },
];

export const team = [
  {
    id: "t1",
    name: "James Salmon",
    role: "Managing Director",
    img: "https://images.unsplash.com/photo-1672748341520-6a839e6c05bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "t2",
    name: "Michael Salmon",
    role: "Contracts Director",
    img: "https://images.unsplash.com/photo-1646227655685-a530813759b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "t3",
    name: "David Turner",
    role: "Contract Manager",
    img: "https://images.unsplash.com/photo-1591588582259-e675bd2e6088?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "t4",
    name: "Sarah Bennett",
    role: "Site Manager",
    img: "https://images.unsplash.com/photo-1679679811837-c28b2586f533?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const testimonials = [
  {
    id: "ts1",
    text: "Salmons Brothers took our new build from drawings to completion without a hitch. Honest, tidy and genuinely cared about getting every detail right.",
    name: "Helen & Mark Whitfield",
    role: "New Build Client, Ely",
  },
  {
    id: "ts2",
    text: "A family firm you can actually trust. Our contract manager kept us informed at every stage and the quality of the work is second to none.",
    name: "Robert Hayes",
    role: "Renovation Client, Cambridge",
  },
  {
    id: "ts3",
    text: "No job was too small. From first meeting to handover the team were professional, reliable and a pleasure to have on site.",
    name: "Angela Foster",
    role: "Extension Client, Soham",
  },
];

export const blog = [
  {
    id: "b1",
    title: "Key Steps to Ensure a Smooth Building Process",
    excerpt:
      "Planning a build can feel daunting. Here are the steps our contract managers follow to keep every project running smoothly from start to finish.",
    day: "24",
    month: "April",
    year: "2025",
    author: "Admin",
    comments: 5,
    img: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "b2",
    title: "Why Family Values Still Matter in Construction",
    excerpt:
      "Trading since 1965, we explain how honesty, integrity, quality and trust continue to shape everything we build today.",
    day: "30",
    month: "June",
    year: "2025",
    author: "Admin",
    comments: 3,
    img: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "b3",
    title: "Choosing the Right Foundations for Your Project",
    excerpt:
      "Every great build starts below ground. We share how the right groundworks give your project the strongest possible start.",
    day: "12",
    month: "March",
    year: "2025",
    author: "Admin",
    comments: 2,
    img: "https://images.unsplash.com/photo-1582540730843-f4418d96ccbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const gallery = [
  "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1701850009190-2859ba2aeea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1731185752376-a4cf3e8556fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1593786267440-550458cc882a?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
];

export const values = [
  { title: "Honesty", desc: "Straight-talking advice and transparent pricing on every project, big or small." },
  { title: "Integrity", desc: "We do what we say we will, and we stand behind the quality of our work." },
  { title: "Quality", desc: "High quality staff and trusted sub-contractors delivering a finish to be proud of." },
  { title: "Trust", desc: "A relationship built over 60 years with clients who return to us again and again." },
];

export const featurePoints = [
  "100% satisfaction guarantee",
  "On-time delivery, every time",
  "Safe, reliable and professional",
];
